import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskCpf, maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';


import { TextField } from '@material-ui/core';
import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles';
import PasswordInput from '../ReusableComponents/PasswordInput';
class EditarCandidatoConflito extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      cpf: '',
      nascimento: moment().subtract(16, 'years'),
      imagem: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      faculdade: { name: '' },
      path_image: undefined,
      numero_inscricao: ''
    };


  }

  get_candidato(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_candidato_error/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false, faculdade: resp.aluno.faculdade,
            name: resp.aluno.name,
            email: resp.aluno.email,
            cpf: resp.aluno.cpf,
            nascimento: moment(resp.aluno.nascimento),
            numero_inscricao: resp.aluno.numero_inscricao,
            path_image: resp.aluno.imagem != null ? resp.aluno.imagem : undefined


          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }



  salvar(e) {
    e.preventDefault();
    this.setState({ loading_save: true, msgErro: '' });
    let form = new FormData();
    form.append('cpf', this.state.cpf);

    form.append('candidato_id', this.props.match.params.id);




    fetch(`${URL}api/faculdade/store_candidato_conflito`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
      },
      body: form
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          window.scrollTo(500, 0);

          this.setState({ loading_save: false, msgErro: erro });
        } else
        {

          this.setState({ loading_save: false });
          this.props.history.push({
            pathname: `/instituicao/show/${this.state.faculdade.id}`,

            search: '?' + new URLSearchParams({ tab: '4' }).toString()
          });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

      }

    }).
    catch((err) => {
      console.log(err);
      this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
    });
  }


  componentDidMount() {
    this.get_candidato(this.props.match.params.id);
  }





  change_tipo(event) {
    this.setState({ tipo: event.target.value });
  }


  render() {
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={`/instituicao/show/${this.state.faculdade.id}`} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">


                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("ui_editar_candidato_de3b0830")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Edite um candidato com conflito {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_da_instituicao") : this.context.t("legacy_do_processo")} {this.state.faculdade.name}</p>
                            <br />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                   
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_name")} `}<Attention /></Form.Label>
                                            <Input
                        disabled
                        placeholder={this.context.t("legacy_nome_do_aluno")}
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_email")} `}<Attention /></Form.Label>
                                            <Input
                        disabled
                        placeholder={this.context.t("label_email")}
                        value={this.state.email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    
                                   
                                    
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("legacy_cpf")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_cpf")}
                        value={this.state.cpf}
                        onChange={(e) => this.setState({ cpf: maskCpf(e.target.value) })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                      <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                      </Link> */}
                                        <DefaultButton
                      bg="secondary"
                      text={this.context.t("back")}
                      icon={<RiArrowGoBackLine />}
                      search={'?' + new URLSearchParams({ tab: 4 }).toString()}
                      to={`/instituicao/show/${this.state.faculdade.id}`} />

                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                      {this.state.loading ? <Spinner /> : ""}
                      Registrar usuário
                      </Button> */}
                                        <DefaultButton
                      type="submit"
                      bg="confirm"
                      text={this.context.t("legacy_salvar_aluno")}
                      disabled={this.state.loading_image == true}
                      loadingtext="Salvando aluno"
                      loading={this.state.loading_save} />

                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                                        <div className="spinner-border text-primary" role="status">
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status">
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  user: state.AppReducer.user,
  token: state.AppReducer.token
});


export default connect(mapsStateToProps, { logout })(EditarCandidatoConflito);